import { Controller } from '@hotwired/stimulus';

const DEBOUNCE_MS = 500;

const FIELDS = {
  gross_salary_low: 'job_ad_form[gross_salary_low]',
  gross_salary_high: 'job_ad_form[gross_salary_high]',
  currency_code: 'job_ad_form[currency_code]',
  experience_level: 'job_ad_form[experience_level]'
};

export default class extends Controller {
  static targets = ['frame'];

  static values = { url: String, debounce: { type: Number, default: DEBOUNCE_MS } };

  connect() {
    this.reload = this.reload.bind(this);
    this.form?.addEventListener('input', this.reload);
    this.form?.addEventListener('change', this.reload);
  }

  disconnect() {
    clearTimeout(this.timer);
    this.form?.removeEventListener('input', this.reload);
    this.form?.removeEventListener('change', this.reload);
  }

  reload() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.load(), this.debounceValue);
  }

  // Pointing the frame somewhere new while it is still fetching aborts the request in
  // flight, and Turbo reports that as an uncaught AbortError. Wait for the one running to
  // land and go again with the latest answers, so the last edit wins.
  load() {
    const url = new URL(this.urlValue, window.location.origin);
    Object.entries(this.answers()).forEach(([key, value]) => url.searchParams.set(key, value));
    if (url.toString() === this.frameTarget.src) return;

    if (this.loading) {
      this.pending = true;
      return;
    }

    this.pending = false;
    this.loading = true;
    this.frameTarget.src = url.toString();
  }

  settled() {
    this.loading = false;
    if (this.pending) this.load();
  }

  answers() {
    return Object.entries(FIELDS).reduce((answers, [param, name]) => {
      answers[param] = this.valueOf(name);
      return answers;
    }, {});
  }

  valueOf(name) {
    const field = this.form?.elements[name];
    if (!field) return '';
    if (!(field instanceof RadioNodeList)) return field.value ?? '';

    return Array.from(field).find(entry => !entry.disabled)?.value ?? '';
  }

  get form() {
    return this.element.closest('form');
  }
}
